<template>
  <div>
    <Skeleton height="2rem" width="25rem" class="mb-5" />
    <div v-for="i in 8" :key="i" class="mb-5">
      <Skeleton width="10rem" class="mb-2" />
      <Skeleton height="2.25rem" class="p-mb-2" />
    </div>
  </div>
</template>
